import { ReactNode } from 'react';

/** @public */
export type SidebarProps = {
  collapseMode: 'responsive' | 'fixed';
  expanded: boolean;
  isNotPersistent: boolean;
  isNotChildOfHeader: boolean;
  hideOverlay: boolean;
  children?: ReactNode;
};

/**
 * Passing children into the desktop or mobile sidebar depending on the context
 *
 * @public
 */
export const LeftPanel = (props: SidebarProps) => {
  const {
    children,
    collapseMode,
    expanded,
    isNotPersistent,
    isNotChildOfHeader,
    hideOverlay,
  } = props;

  return (
    <>
      <cds-left-panel
        collapse-mode={collapseMode}
        expanded={expanded ? 'true' : null}
        is-not-child-of-header={isNotChildOfHeader}
        hide-overlay={hideOverlay}
        is-not-persistent={isNotPersistent}
      >
        {children ? children : null}
      </cds-left-panel>
    </>
  );
};
